import { render } from "./ApplicationsAdmin.vue?vue&type=template&id=c4d79a4a&scoped=true"
import script from "./ApplicationsAdmin.vue?vue&type=script&lang=js"
export * from "./ApplicationsAdmin.vue?vue&type=script&lang=js"

import "./ApplicationsAdmin.vue?vue&type=style&index=0&id=c4d79a4a&scoped=true&lang=css"
import "./ApplicationsAdmin.vue?vue&type=style&index=1&id=c4d79a4a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d79a4a"]])

export default __exports__